<div class="coaching-card">
    <cmps-card-component
        class="insight-component-item"
        [cardNameLabel]="_i18n._9916_MY_COACHING | translate"
        [isLoading]="state.pending.reload"
        [hasExpandAction]="state.pending.hasData"
        [disabledDropdown]="true"
        [isExpanded]="_isExpanded"
        [hasRefreshAction]="_isExpanded === false && state.pending.hasData"
        (refreshAction)="_onReload()"
        (expandAction)="_toggleExpand()"
        [data]="bodyContent"
    ></cmps-card-component>
</div>

<ng-template #bodyContent>
    <ng-container *ngIf="!state.pending.hasData && !state.pending.reload">
        <div class="my-coaching-card--no-data">
            <h2 class="my-coaching-card--no-data-value">
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </h2>
        </div>
    </ng-container>
    <ng-container *ngIf="state?.cardItems">
        <ng-container
            *ngFor="let item of state.cardItems; let rowIndex = index"
        >
            <cmps-card-header-row-component
                *ngIf="_isExpanded == false && state.pending.hasData"
                [cardHeaderLabel]="item.headerData?.titleLabel | translate"
                [timePeriod]="item.headerData?.periodDate"
                [isShowingIcon]="false"
            ></cmps-card-header-row-component>

            <div class="data-rows-container">
                <ng-template
                    ngFor
                    let-i
                    [ngForOf]="item.cardRowsData"
                >
                    <cmps-card-data-row
                        *ngIf="_isExpanded === false && i.rowData.isVisible"
                        [rowData]="i.rowData"
                        [progressData]="i.progressData"
                        [dropdownMenuData]="i.dropdownMenuData"
                        [trendButtonTemplate]="
                            i.rowData.rowType !== _rowType.OA_CHILD
                                ? trendButton
                                : null
                        "
                        (selectedAction)="_onSelectItem($event)"
                        (rowClickAction)="_onRowClickToggleExpand($event)"
                        (closeAction)="_onClose(i.id)"
                    ></cmps-card-data-row>
                    <ng-template #trendButton>
                        <button
                            cmpsTooltipTrigger="{{
                                (state.selectedRows?.[rowIndex]
                                    ? _i18n._10076_CLOSE_TREND
                                    : _i18n._10075_VIEW_TREND
                                ) | translate
                            }}"
                            [ngClass]="{
                                'trend-view-button--selected':
                                    state.selectedRows?.[rowIndex]
                            }"
                            class="trend-view-button"
                            (click)="
                                $event.stopPropagation();
                                _onTrendButtonClick(i.rowData.rowType, rowIndex)
                            "
                        >
                            <cmps-icon
                                svgIcon="scorecard:trend"
                                class="ml-2"
                            ></cmps-icon>
                        </button>
                    </ng-template>
                </ng-template>
            </div>
            <div
                *ngIf="
                    state.selectedRows?.[rowIndex] === true &&
                    _isExpanded === false
                "
            >
                <div class="chart-header-container">
                    <span class="chart-header-label">
                        {{ state.chartDataByRow?.[rowIndex]?.trendTitle }}
                    </span>
                    <button
                        class="cmps-button--no-bg chart-header-close-btn"
                        cmpsButton
                        (click)="_onCloseClick(rowIndex)"
                    >
                        <cmps-icon svgIcon="close"></cmps-icon>
                    </button>
                </div>
                <div class="trend-chart-wrapper">
                    <span
                        class="trend-chart--y-axis-title"
                        *ngIf="
                            state.chartDataByRow?.[rowIndex]?.paths?.[0].points
                                .length > 0
                        "
                    >
                        {{ state.chartDataByRow?.[rowIndex]?.yAxisTitle }}
                    </span>
                    <cmps-mi2-trend-dialog
                        [_data]="state.chartDataByRow?.[rowIndex]"
                    ></cmps-mi2-trend-dialog>
                </div>

                <span
                    class="trend-chart--x-axis-title"
                    *ngIf="
                        state.chartDataByRow?.[rowIndex]?.paths?.[0].points
                            .length > 0
                    "
                >
                    {{ _i18n._828_MONTH | translate }}
                </span>

                <div class="legends-wrapper">
                    <div
                        class="legend-container"
                        *ngFor="
                            let legend of state.chartDataByRow?.[rowIndex]
                                ?.legends
                        "
                    >
                        <ng-container>
                            <div
                                class="legend"
                                [style.backgroundColor]="legend.color"
                            ></div>
                            <span class="legend-label">{{ legend.label }}</span>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="_isExpanded === true">
            <div cmpsWidgetCoachingInsightNext></div>
        </ng-container>
    </ng-container>
</ng-template>
